import { RouteLocationRaw } from "vue-router";

export type BreadcrumbItemType = {
  title: string,
  disabled?: boolean,
  href?: string | undefined,
  replace?: boolean | undefined,
  to?: RouteLocationRaw | undefined,
  exact?: boolean | undefined,
} | string

const TOP_ITEM : BreadcrumbItemType = {
  title: 'トップページ',
  to: '/',
  disabled: false,
}

const CART_ITEM : BreadcrumbItemType = {
  title: 'カート',
  to: '/cart',
  disabled: false,
}


const MYPAGE_ITEM : BreadcrumbItemType = {
  title: 'マイページ',
  to: '/mypage',
  disabled: false,
}

export function useBreadcrumbsFunc() {

  /**
   * 
   * @param settings 
   * @returns 
   */
  function getTopItem(available: boolean = true): BreadcrumbItemType {
    return Object.assign(TOP_ITEM, { disabled: !available });
  }

  function getCartItem(available: boolean = true): BreadcrumbItemType {
    return Object.assign(CART_ITEM, { disabled: !available });
  }

  function getMypageItem(available: boolean = true): BreadcrumbItemType {
    return Object.assign(MYPAGE_ITEM, { disabled: !available });
  }

  return {
    getTopItem,
    getCartItem,
    getMypageItem,
  };
}
